import React from "react";
import Banner from "../base/Banner";
import AgencyPosition from "./AgencyPosition";
import getCustomerData from "../../services/DataGetter";
import {setLanguage} from "../../enums/Languages";

export default class AgencyComponent extends React.PureComponent
{

    constructor(props){
       super(props);
       this.state = {
           customerData: getCustomerData(this.props.match.params['customerName']),
           language: setLanguage(this.props.match.params['lang'])
       };
    }

    render() {
        const {customerData} = this.state;
        return (
            <>
                <Banner
                    customerName={this.props.match.params['customerName']}
                    language={this.state['language']}
                    disableURL={true}
                    isAgency={true}
                    customerData={customerData}
                    link={`/${this.language}/gate/${this.props.match.params['customerName']}/agency/${this.props.match.params['agencyHash']}/add-candidate`}
                />
                <AgencyPosition
                    customerName={this.props.match.params['customerName']}
                    language={this.state['language']}
                    customerData={customerData}
                    agency={this.props.match.params['agencyHash']}
                    positionId={this.props.match.params['positionId']}
                />
            </>);
    }
}
